import styled, { css } from 'styled-components'
import { rem } from 'utils/common'
import { device } from '../Variable'

export const LayoutStyle = styled.div`
	padding: ${rem(80, 0, 100)};
	@media (${device.mobileL}) {
		padding-top: ${rem(64, 0, 100)};
	}
`
export const Body = styled.div`
	position: relative;
	padding: ${rem(0, 32)};
	max-width: 100%;
	${(p) =>
		p.path !== '/login' &&
		css`
			padding: ${rem(0, 32)};
			@media (${device.tablet}) {
				padding: ${rem(0, 15)};
			}
		`}
`
